// src/components/HorizontalBlade.js
import React from 'react';
import Blade from './mainblade';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const HorizontalBladeRoot = styled(Blade)(({ theme }) => ({
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  gap: theme.spacing(4),
  padding: theme.spacing(4),
  alignItems: 'center', // Default alignment
}));

const HorizontalBlade = ({ children, ...props }) => (
  <HorizontalBladeRoot {...props}>
    {children}
  </HorizontalBladeRoot>
);

export const FeatureIcon = styled(Box)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontSize: '3rem',
  zIndex: 2,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    marginBottom: 0,
    marginRight: theme.spacing(3),
  },
}));

export const StyledFeatureTypography = styled(Box)(({theme}) => ({
  color: '#f0f0f0',
  fontWeight: 600,
  zIndex: 2,
  textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
  fontSize: '1.5rem',
  marginBottom: theme.spacing(1),
  [theme.breakpoints.up('md')]: {
    marginBottom: 0,
  },
}));

export default HorizontalBlade;